export const mapPinTrackingType = {
  UPDATED: 'Updated',
  SEEN: 'Seen',
  NEW: 'New',
  ORIGINAL: 'Original',
}

export const getTracking = listing =>
  listing?.primary_property?.current_user_tracking_state || {}

/**
 * Returns an object for the different tracking variants which will evaluate if the variant is enabled AND true.
 * @param {*} listing
 * @param {*} featureFlags
 * @returns
 */
export const getMapPinTrackingInfo = (listing, featureFlags) => ({
  [mapPinTrackingType.UPDATED]:
    featureFlags['fe.resi.search.map-marker-updated-label'] &&
    getTracking(listing).is_updated,
  [mapPinTrackingType.SEEN]: getTracking(listing).is_seen,
  [mapPinTrackingType.NEW]: listing?.primary_property?.is_newly_listed,
})
